import 'alpinejs';
import 'lazysizes';
import 'parsleyjs';
import Swup from 'swup';

// Scroll to top logic
var scrollTop = document.getElementById("scrollTop");
var rootElement = document.documentElement;

function scrollToTop() {
    rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
    })
}
scrollTop.addEventListener("click", scrollToTop);

$(document).ready(function() {
  $('html').removeClass('is-animating');
});

const options = {
    containers: ["#swup", "#myNav", "#bg", "#myFooter"],
    linkSelector: 'a.anim-link',
    animationSelector: '[class*="my-transition-"]'
};
const swup = new Swup(options);

swup.on('contentReplaced', function () {
    window.scrollTo(0, 0);

    $('.forms').parsley();

    var scrollTop = document.getElementById("scrollTop");
    var rootElement = document.documentElement;

    function scrollToTop() {
        rootElement.scrollTo({
            top: 0,
            behavior: "smooth"
        })
    }

    scrollTop.addEventListener("click", scrollToTop);
});
